/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/ImageRadio/index.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React, { useContext } from "react";
import { FormContext } from '@proxy/_contexts';
import { md5, getImage } from "@root/_utils"

export default function ImageRadio({ images, category, inputName, onChange, value }) {

  const { settings }  = useContext(FormContext);

  const inputMarkup = images ? images.map((imageUrl, index) => {

    const imageNameIndex  = imageUrl.lastIndexOf('/');
    const imagePath       = imageUrl.substring(0, imageNameIndex + 1);
    const thumbnailName   = "thumb-" + imageUrl.substring(imageNameIndex + 1);
    const thumbnailUrl    = imagePath + thumbnailName;
    const hasThumbnail    = (Array.isArray(settings?.files?.files?.images)) ? settings.files.files.images.find((img) => img === thumbnailName) : false;

    const inputValue  = `${getImage(imageUrl)}?key=${md5(`${imageUrl}${index}${category}`)}`;
    const imgSrc      = getImage((hasThumbnail) ? thumbnailUrl : imageUrl);
    const isChecked   = inputValue.includes(value) && value !== "" && value !== null && typeof(value) != 'undefined';

    return (
      <div
        key={`imageRadioButton${index}${category}${imageUrl}`}
        className={`gc__image_radio_button_container ${(isChecked) ? "gc__checked" : ""}`}
      >
        {isChecked ? (
          <div className="gc__absolute-icon"><span className="gc__icon"><svg viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fillRule="evenodd" d="M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4L9 11.6 6.7 9.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"></path></svg></span></div>
        ) : <></>}

        <label className={"gc__image_radio_label"}>
          <input
            className={"gc__image_radio_input"}
            type="radio"
            name={inputName}
            value={inputValue}
            onChange={() => onChange(inputValue)}
            checked={isChecked}
          />
          <div className="cover atvImg">
            <div className="atvImg-layer" data-img={imgSrc}></div>
            <div className="atvImg-layer" data-img={imgSrc}></div>
          </div>
          <img className={"gc__giftcard-radio-image"} src={imgSrc} alt="" />
        </label>
      </div>
    );

  }) : [];

  return (
    <div className={"gc__radio_buttons_container"} >
      {inputMarkup}
    </div>
  );
};
